const proxyTargets = {
  dmp: "https://www.dmp.eis-deliverydevqa.cloud",
  dhe: "https://www.dh.eis-deliverydevqa.cloud",
  dmx: "https://www.dmx.eis-deliverydevqa.cloud",
};

const baseUrl =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
    ? proxyTargets[process.env.REACT_APP_PRODUCT_CODE]
    : "";

const apiConfig = {
  "home-edge": `${baseUrl}/api/home`,
  baseUrl,
};

export default apiConfig;
